import { DocumentStatus, PolicyDocument } from '@interfaces/documents.interface';

const DRAFT_HTML = `<!DOCTYPE html><html><head><style>
body { font-family: Arial, sans-serif; font-size: 12px; color: #1b1b21; }
table { width: 100%; border-collapse: collapse; margin-bottom: 16px; }
th { border: 1px solid #ccc; padding: 8px; background: #ededed; text-align: left; }
td { border: 1px solid #ccc; padding: 8px; }
.page-break { page-break-after: always; }
</style></head><body>
<div data-immutable=""><h1>CONDICIONES PARTICULARES</h1></div>
<p>La vigencia de esta póliza corresponde a:</p>
<table>
	<thead><tr><th>Fecha Vigencia Inicial</th><th>Fecha Vigencia Final</th></tr></thead>
	<tbody><tr><td>01-01-2026</td><td>31-12-2026</td></tr></tbody>
</table>
<table>
	<thead><tr><th colspan="2">Datos del Contratante</th></tr></thead>
	<tbody><tr><td>Razón social</td><td>Empresa Ejemplo S.A.</td></tr></tbody>
</table>
<table>
	<thead><tr><th colspan="2">Datos del Asegurador</th></tr></thead>
	<tbody><tr><td>Razón social</td><td>Vida Cámara S.A.</td></tr></tbody>
</table>
<p>Texto editable de ejemplo para el borrador del documento.</p>
<div class="page-break"></div>
<h2>2. COBERTURAS CONTRATADAS</h2>
<table>
	<thead><tr><th>Cobertura</th><th>Capital Asegurado</th><th>% Contratante</th><th>% Asegurado</th></tr></thead>
	<tbody>
		<tr><td>Fallecimiento</td><td>UF 500</td><td>100%</td><td>0%</td></tr>
		<tr><td>Invalidez total y permanente</td><td>UF 300</td><td>100%</td><td>0%</td></tr>
		<tr><td>Muerte accidental</td><td>UF 500</td><td>80%</td><td>20%</td></tr>
		<tr><td>Reembolso salud</td><td>UF 100</td><td>50%</td><td>50%</td></tr>
	</tbody>
</table>
<p>Las coberturas anteriores rigen para todos los asegurados vigentes de la nómina, según las condiciones generales depositadas en la CMF.</p>
<div class="page-break"></div>
<h2>3. RESUMEN DE LAS CONDICIONES DEL SEGURO</h2>
<p>El presente documento constituye un resumen de las condiciones particulares del seguro colectivo contratado. Ante cualquier discrepancia entre este resumen y las condiciones generales, prevalecerán estas últimas.</p>
<table>
	<thead><tr><th>Deducible por Grupo Familiar</th><th>Aplica Sobre Prestaciones Salud</th></tr></thead>
	<tbody><tr><td>UF 1,5</td><td>Sí</td></tr></tbody>
</table>
<p>Texto legal editable de ejemplo: el contratante declara conocer y aceptar las condiciones del presente contrato de seguro.</p>
</body></html>`;

export const buildMockDocument = (policyId: string, status: DocumentStatus): PolicyDocument => ({
	id: 'e5a1c1e0-0000-4000-8000-000000000001',
	type: 'documents-health-pyme',
	version: 1,
	status,
	file: DRAFT_HTML,
	metadata: { policyId, policyNumber: 1026, renewalNumber: 12 },
	attributes: {},
});
